import { Component, OnInit } from '@angular/core';
import { NoticiasService } from 'src/app/services/noticias.service';
import { Noticia } from 'src/app/models/noticia.model';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.css']
})
export class LegalComponent implements OnInit {

  public noticias : Noticia[]
  
  constructor(ns: NoticiasService)
  {
      ns.getNoticiasLegal()
      .subscribe((dados: Noticia[]) => this.noticias = dados);
  }

  ngOnInit(): void {
  }

}
